__turbopack_context__.v({
  "root": "checkout-module__dZxkZW__root",
  "shippingLabelFadeIn": "checkout-module__dZxkZW__shippingLabelFadeIn",
});
